import React from "react";
import { FiEye, FiTarget } from "react-icons/fi";

const MissionVision = () => {
  return (
    <section id="mission-vision" className="vision-mission-section">
      <div className="section-container">
        <div className="section-header-center">
          <h2 className="section-title">Mission & Vision</h2>
          <div className="title-underline"></div>
        </div>
        <div className="vision-mission-grid">
          <div className="vm-card">
            <FiEye className="vm-icon" />
            <h3 className="vm-title">Our Vision</h3>
            <p className="vm-description">
              To power inclusive, data-driven lending across Africa, transforming how
              financial institutions assess and serve their customers.
            </p>
          </div>

          <div className="vm-card">
            <FiTarget className="vm-icon" />
            <h3 className="vm-title">Our Mission</h3>
            <p className="vm-description">
              To empower financial institutions with intelligent tools that make credit
              more accessible, transparent, and efficient for everyone.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;